import { useMutation } from '@tanstack/react-query';

import {
  type SaveStudentSessionAttendanceInput,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { groupsKeys } from '@tyro/groups';
import { useTranslation } from '@tyro/i18n';
import { reportsKeys } from '@tyro/reporting';
import { attendanceKeys } from './keys';

const saveStudentSessionAttendance = graphql(/* GraphQL */ `
  mutation saveStudentSessionAttendance(
    $input: SaveStudentSessionAttendanceInput
  ) {
    attendance_saveStudentSessionAttendance(input: $input) {
      studentPartyId
    }
  }
`);

export function useCreateOrUpdateSessionAttendance() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: async (input: SaveStudentSessionAttendanceInput) =>
      gqlClient.request(saveStudentSessionAttendance, { input }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: attendanceKeys.all }),
        queryClient.invalidateQueries({ queryKey: groupsKeys.subject.all() }),
        queryClient.invalidateQueries({ queryKey: reportsKeys.all }),
      ]);

      toast.success(t('common:snackbarMessages.updateSuccess'));
    },
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
  });
}
